var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11328 20.4355C8.36719 20.4355 8.58203 20.3379 8.74805 20.1719L16.4922 12.6035C16.6777 12.418 16.7754 12.1934 16.7754 11.9492C16.7754 11.6953 16.6777 11.4609 16.4922 11.2949L8.75781 3.73633C8.58203 3.56055 8.36719 3.46289 8.11328 3.46289C7.60547 3.46289 7.22461 3.85352 7.22461 4.36133C7.22461 4.5957 7.32227 4.83008 7.47852 4.99609L14.5879 11.9492L7.47852 18.9023C7.32227 19.0684 7.22461 19.293 7.22461 19.5371C7.22461 20.0449 7.60547 20.4355 8.11328 20.4355Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.5023244d03c50048c0fdf1210b763b07.svg";
export { ForwardRef as ReactComponent };